import React, { useState } from 'react';

export const CardNotificaciones = ({
    titulo,
    contenido,
    className = '',
    style = {},
    styleTitle = {},
    onClose
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isCloseHovered, setIsCloseHovered] = useState(false)

    return (
        <div
            className={'card mx-1 ' + className}
            style={{
                background: isHovered ? 'rgba(0, 0, 0, 0.95)' : 'rgba(0, 0, 0, 0.6)',
                transform: isHovered ? 'scale(1.01)' : 'scale(1)',
                transition: 'all 0.2s ease-in-out',
                cursor: isHovered ? 'pointer' : 'default',
                padding: 0,
                justifyContent: "center",
                width: '95%', 
                transform: isHovered ? 'scale(1.08)' : 'scale(1)',
                marginTop: 25,
                position: 'relative',
                ...style
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* Título */}
            <div
                className='text-truncate px-2'
                style={{
                    marginLeft: 15,
                    padding: 0,
                    position: "absolute",
                    top: -16,
                    border: "none",
                    borderRadius: '5px',
                    maxWidth: "80%",
                    background: '#1b2f6f',
                    ...styleTitle
                }}
            >
                <span style={{ color: 'white' }}>{titulo}</span>
            </div>

           {/* Botón cerrar */}
            {onClose && (
                <button
                    // onClick={onClose}
                    onClick={(e) => {
                        e.stopPropagation(); // <-- Detiene que el click se propague al div padre
                        onClose();
                    }}
                    title="Descartar"
                    onMouseEnter={() => setIsCloseHovered(true)}
                    onMouseLeave={() => setIsCloseHovered(false)}
                    style={{
                        position: 'absolute',
                        top: 5,
                        right: 10,
                        background: 'transparent',
                        border: 'none',
                        color: isCloseHovered ? 'red' : 'white',
                        fontSize: '1.2rem',
                        cursor: 'pointer',
                        transition: 'color 0.2s ease-in-out',
                    }}
                    aria-label="Cerrar"
                >
                    x
                </button>
            )}

            {/* Contenido */}
            <div className={'pt-2 px-2 pb-1 cardContenidoNoficacion'}>
                {contenido}
            </div>
        </div>
    );
};

export default CardNotificaciones;